/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_SubtitleInputs */

const en_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle`)
};

const fr_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres`)
};

const de_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitolo`)
};

const ru_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitular`)
};

const zh_cn2_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_edit_event_group_type_subtitle = /** @type {(inputs: Edit_Event_Group_Type_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {Edit_Event_Group_Type_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_subtitle = /** @type {((inputs?: Edit_Event_Group_Type_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_subtitle(inputs)
	if (locale === "de") return de_edit_event_group_type_subtitle(inputs)
	if (locale === "it") return it_edit_event_group_type_subtitle(inputs)
	if (locale === "ru") return ru_edit_event_group_type_subtitle(inputs)
	if (locale === "es") return es_edit_event_group_type_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_subtitle(inputs)
	if (locale === "ja") return ja_edit_event_group_type_subtitle(inputs)
	if (locale === "hi") return hi_edit_event_group_type_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_subtitle(inputs)
	return en_edit_event_group_type_subtitle(inputs)
});